module.exports = __webpack_public_path__ + "img/manzana.9557f5f9.png";